import React, { Component } from 'react';
import { Box, Container, Grid } from '@mui/material';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

// Internal
import { useStyles } from '../main/styles';
import withMediaQuery from '../../constants/mediaQuery';
import { translateEvents } from '../../utils/events';
import { eventDescriptionStyle } from '../../utils/eventDescriptionStyle';
import EventTimelineIcon from '../../components/TrackingCode/EventTimelineIcon';

// HOC to inject styles into class component
// no-dd-sa:javascript-code-style/parameter-name
const withUseStyles = (WrappedComponent) => {
  return function WithStylesWrapper(props) {
    const classes = useStyles();
    return <WrappedComponent {...props} classes={classes} />;
  };
};

class Timeline extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { store, match } = this.props;
    const { deliveryStore } = store;
    if (match?.params && match.params.tracking_code) {
      deliveryStore.getDelivery(match.params.tracking_code, null);
    }
  }

  render() {
    const { classes, store } = this.props;
    const { delivery } = store.deliveryStore;
    if (!delivery) return null;

    const { shipment, outbound_events } = delivery;
    const translatedEvents = translateEvents(outbound_events || [], shipment);

    return (
      <Grid size={{ xs: 12, sm: 6 }} sx={classes.bodyItemWrapper}>
        <Container sx={classes.bodyBottomItem}>
          {translatedEvents.map((event, idx) => {
            const text = event.description;

            if (!text) return null;

            const eventDate = moment(event.ts)
              .tz(shipment.timezone || 'America/Los_Angeles')
              .format('MMM DD');
            const eventTime = moment(event.ts)
              .tz(shipment.timezone || 'America/Los_Angeles')
              .format('hh:mm A');

            return (
              <Grid key={`event-${idx}`} container sx={classes.deliveryStep} alignItems="center">
                <Grid size={3} sx={{ ...classes.deliveryStepCell, ...classes.deliveryStepCellDateTime }}>
                  <Box sx={classes.deliveryStepDate}>{eventDate}</Box>
                  <Box sx={classes.deliveryStepTime}>{eventTime}</Box>
                </Grid>
                <Grid
                  size={1}
                  sx={{
                    ...classes.deliveryStepCell,
                    ...classes.deliveryStepCellIcon,
                    ...(idx + 1 < translatedEvents.length && classes.deliveryStepConnector),
                  }}
                >
                  <EventTimelineIcon event={event} />
                </Grid>
                <Grid size={9} sx={classes.deliveryStepCell}>
                  <Box sx={eventDescriptionStyle(event)}>{text}</Box>
                </Grid>
              </Grid>
            );
          })}
        </Container>
      </Grid>
    );
  }
}

const TimelineCompose = compose(inject('store'), observer)(Timeline);

// Wrapper component to provide router hooks to class component
function TimelineWrapper(props) {
  const params = useParams();
  return <TimelineCompose {...props} match={{ params }} />;
}

export default withUseStyles(withMediaQuery()(TimelineWrapper));
